import React, { forwardRef } from "react";
import styles from "./Typography.module.css";
import { ITypography } from "../../models/ITypography";

const Typography: React.FC<ITypography> = forwardRef<HTMLParagraphElement, ITypography>(
	({ size = "md", fontFamily = "regular", color = "primary", type = "text", style = {}, ...props }: ITypography, ref) => {
		return (
			<p
				className={`${styles.typography} ${styles["size_" + size]} ${styles["color_" + color]} ${styles["type_" + type]} ${styles["font_" + fontFamily]} ${props.className ?? ""}`}
				style={style}
				ref={ref}
			>
				{props.children}
			</p>
		);
	}
);

Typography.displayName = "Typography";
export default Typography;
